export const environment = {
  production: false,
  maintenanceMode: false,
  appCode: 'inventory-report',
  // デバッグモード
  debug: false,
  /** Garage 在庫報告／納品計画API */
  inventoryApiUrl: 'https://api.out.inventory-report.nakamenosakura.com/api',
  inventoryTaskApiUrl:
    'https://task.out.inventory-report.nakamenosakura.com/api',
  inventoryBackendApiUrl:
    'https://backend.out.inventory-report.nakamenosakura.com/api',
  /** SORS用途別引当数 UI */
  inventorySorsUiUrl:
    'https://stg03-sors.shimamura-api.com/inventory-reservation/',
  /** 共通バックエンドAPI */
  applicationActuateMacroApiUrl:
    '//backend-applicationactuatemacroapi.backend.out.nakamenosakura.com/api',
  /** バックエンドマクロAPI */
  backendMacroApiUrl:
    'https://backend-macroapi.backend.out.nakamenosakura.com/api',
  /** 貿易部GarageAPI */
  smTradeGarageApiUrl:
    'https://sm-trade-garage-oapi-net6.garage.out.nakamenosakura.com',
  /** Garageバックエンド(IsBiz) API */
  garageBackendApiUrl: 'https://isbiz-oapi-net6.garage.out.nakamenosakura.com',
  /** Garage Filebox API */
  garageFileboxApiUrl:
    'https://filebox.oapi-net6.garage.out.nakamenosakura.com',
  /** My-idea UI */
  myIdeaUiUrl: 'https://myidea.backend.out.nakamenosakura.com',
  // 本番では利用しない。
  indexCoreApiUrl:
    'https://index-core-infra-api.isbe.in.nakamenosakura.com/api',

  /** ProSche入力補助UI */
  proScheInputAssistanceUiUrl: 'https://group-list-editor.nakamenosakura.com',
  proScheInspectionAppUiUrl: 'https://group-list-editor.nakamenosakura.com',
};
